import React from 'react'

const MenuIconMobile = ({ header, title, onClick, children }) => {
    return (
        <div
            style={{
                    width           : '95%', 
                    cursor          : 'pointer', 
                    border          : '1px solid #305496', 
                    backgroundColor : '#fff', 
                    margin          : '8px', 
                    padding         : '1em', 
                    borderRadius    : '10px'
                }}
            onClick={onClick}>
            <div style={{ color:'#305496', fontSize:'14px' }}>{ header }</div>
                {children}
            <div style={{ fontWeight:'bold', color:'#305496', fontSize:'24px' }}>{ title }</div>
        </div>
    )
  }
  
  export default MenuIconMobile
